import {makeAutoObservable} from "mobx";
import {IRmaPolicyRule} from "../rma-types";
import RmaResolutionStore from "./rma-resolution-store";
import { FEE_TYPE } from "../../../policies/policy-types";
import { RESOLUTION_IDS_OF_TYPE_EXCHANGE, RESOLUTION_IDS_OF_TYPE_ORDER_MODIFICATION, RESOLUTION_ID } from "../../../../pages/resolutions/constants";
import RmaPolicyRuleFeeStore from "./rma-policy-rule-fee-store";
import RmaOfferStore from "./rma-offer-store";
import { CHARGE_FEES } from "../../../policies/constants";

class RmaPolicyRuleStore {
    private _model: IRmaPolicyRule = {} as IRmaPolicyRule;
    private _rmaResolutionStore: RmaResolutionStore = {} as RmaResolutionStore;
    private _policyRuleFees: RmaPolicyRuleFeeStore[] = [];

    constructor(private _rmaOfferStore: RmaOfferStore, model: IRmaPolicyRule) {
        makeAutoObservable(this, {}, { autoBind: true});
        this._setModel(model);
    }
    
    private _setModel(model: IRmaPolicyRule){
        this._model = model;
        this._rmaResolutionStore = new RmaResolutionStore(model.merchant_resolution_setting);
        this._policyRuleFees = model.policy_rule_fees.map(fee => new RmaPolicyRuleFeeStore(fee));
    }
    
    public get displayName(): string {
        const productCase = this._rmaOfferStore.productCaseStore;
        if (productCase.isHiddenResolution) {
            const policyType = (productCase.exchangeStore) ? 'Exchange' : 'Return';
            return `No Eligible ${policyType} Policy Rule`;
        }
        return this._model.name;
    }
    private get chargeFees(): CHARGE_FEES { return this._model.charge_fees; }
    public get resolution(): RmaResolutionStore { return this._rmaResolutionStore; }
    public get policyRuleFees(): RmaPolicyRuleFeeStore[] { return this._policyRuleFees; }
    
    public get isExchange(): boolean { return RESOLUTION_IDS_OF_TYPE_EXCHANGE.includes(this._rmaResolutionStore.resolutionId); }
    public get isManualExchange(): boolean { return this._rmaResolutionStore.resolutionId === RESOLUTION_ID.MANUAL_EXCHANGE; }
    public get isReturn(): boolean { return ![...RESOLUTION_IDS_OF_TYPE_EXCHANGE, ...RESOLUTION_IDS_OF_TYPE_ORDER_MODIFICATION].includes(this._rmaResolutionStore.resolutionId); }

    public get shouldConsiderCost(): boolean {
        let shouldConsiderCost = false;
        if (this.chargeFees === CHARGE_FEES.CHARGE_FEE) {
            if (this.policyRuleFees.length) {
                this.policyRuleFees.forEach(fee => {
                    if (fee.isCharged && [FEE_TYPE.COST, FEE_TYPE.COST_PLUS_ITEM_FEE, FEE_TYPE.COST_PLUS_SHIPMENT_FEE].includes(fee.feeType)) {
                        shouldConsiderCost = true;
                        return;
                    }
                });
            }
        }
        return shouldConsiderCost;
    }
}

export default RmaPolicyRuleStore;